package com.evoapps.evoshift.domain.usecase.financial

import com.evoapps.evoshift.domain.util.AppClock
import com.evoapps.evoshift.domain.model.AdjustmentType
import com.evoapps.evoshift.domain.model.RosterIds
import com.evoapps.evoshift.domain.usecase.finance.AdjustmentInput
import com.evoapps.evoshift.domain.usecase.finance.SaveAdjustmentUseCase
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.number
import kotlinx.datetime.todayIn

/**
 * Adds a bonus, deduction or expense refund for [userId] in a month without picking a day: dated
 * today when today is in that month, else the month's first day. The screens use
 * [SaveAdjustmentUseCase] (SH-78), which this delegates to (same checks, audit and lock).
 */
class AddFinancialAdjustmentUseCase(
    private val saveAdjustment: SaveAdjustmentUseCase,
    private val today: () -> LocalDate = { AppClock.todayIn(TimeZone.currentSystemDefault()) }
) {
    suspend operator fun invoke(
        rosterId: String,
        userId: String,
        amount: Double,
        type: AdjustmentType,
        description: String,
        managerId: String,
        relatedShiftId: String? = null
    ): Result<Unit> {
        val (year, month) = RosterIds.yearMonthOf(rosterId)
        val day = today().takeIf { it.year == year && it.month.number == month } ?: LocalDate(year, month, 1)
        return saveAdjustment(
            rosterId = rosterId,
            userId = userId,
            input = AdjustmentInput(type, amount, day.toString(), description, relatedShiftId),
            editorId = managerId
        ).map { }
    }
}
